<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/product-level/${inputs.product_level_id}`
						: `master/product-level`
				"
			>
				<div class="form-group row align-items-center">
					<label
						for="inputs_level_id"
						class="col-sm-3 mb-0"
					>
						Product Level ID
					</label>
					<app-input
						id="inputs_level_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.level_id"
						:placeholder="'Product Level ID'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_product_level_code"
						class="col-sm-3 mb-0"
					>
						Product Level Code
					</label>
					<app-input
						id="inputs_product_level_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.product_level_code"
						:placeholder="'Product Level Code'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_product_level_desc"
						class="col-sm-3 mb-0"
					>
						Product Level Desc
					</label>
					<app-input
						id="inputs_product_level_desc"
						class="col-sm-9"
						type="text"
						v-model="inputs.product_level_desc"
						:placeholder="'Product Level Desc'"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
			},
			// statusLists: [
			//     {id: '', value: "Choose One",},
			//     {id: 'active', value: "Active",},
			//     {id: 'inactive', value: "Inactive",},
			//     {id: 'invited', value: "Invite",},
			// ],
			// genderLists: [
			//     {id: 'male', value: "Male"},
			//     {id: 'female', value: "Female"},
			//     {id: 'other', value: "Other"},
			// ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
